module.exports = __webpack_public_path__ + "img/vermouth-rosso-xxl.4d2063dc.png";